import * as React from 'react';
import * as styles from './ContentLayout.css';

export const ContentLayout = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['layout']}>{children}</div>;
};
